import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';

const TransactionLog = ({ prenupId, documentNumber, onClose }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (prenupId) {
      fetchLogs();
    }
  }, [prenupId]);

  const fetchLogs = async () => {
    setLoading(true);
    setError('');
    try {
      const endpoint = prenupId 
        ? `/audit/prenup/${prenupId}`
        : `/audit/document/${documentNumber}`;
      
      const response = await apiService.fetchData(endpoint);

      if (response.success) {
        setLogs(response.data.logs);
      } else {
        setError('حدث خطأ في جلب سجل المعاملات');
      }
    } catch (err) {
      console.error('Error fetching logs:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  const printLogs = () => {
    const tableDiv = document.getElementById('TransactionTableDiv');
    const printWindow = window.open('', '_blank');
    
    printWindow.document.write(`
      <html>
        <head>
          <title>سجل المعاملات</title>
          <meta charset="UTF-8">
          <style>
            body { 
              font-family: 'Cairo', Arial, sans-serif; 
              direction: rtl; 
              text-align: right;
              margin: 20px;
            }
            .header {
              text-align: center;
              margin-bottom: 30px;
              padding: 20px;
              border-bottom: 2px solid #333;
            }
            .header img {
              height: 60px;
              margin-bottom: 10px;
            }
            .header h1 {
              font-size: 18px;
              margin: 10px 0;
              color: #333;
            }
            .header h2 {
              font-size: 16px;
              margin: 5px 0;
              color: #666;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #333;
              padding: 8px;
              text-align: right;
              font-size: 12px;
            }
            th {
              background-color: #f5f5f5;
              font-weight: bold;
            }
            tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            .print-buttons {
              display: none;
            }
            @media print {
              .print-buttons {
                display: none !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <img src="/logo-ar-black.png" alt="شعار وزارة الصحة" />
            <h1>مبادرة السيد رئيس الجمهورية لفحص المقبلين على الزواج</h1>
            <h2>سجل المعاملات</h2>
            ${documentNumber ? `<p>رقم المستند: ${documentNumber}</p>` : ''}
          </div>
          ${tableDiv.innerHTML}
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <div className="transaction-log-overlay">
      <div className="transaction-log-modal">
        {/* Header */}
        <div className="transaction-log-header">
          <div className="header-content">
            <div className="header-logos" hidden>
              <img src="/logo-ar-black.png" alt="شعار وزارة الصحة" className="nav-img" />
              <img src="/100Million.png" alt="100 مليون صحة" className="nav-img" />
            </div>
            <div className="site-name">
              <h4>مبادرة السيد رئيس الجمهورية لإجراء فحوصات ما قبل الزواج</h4>
            </div>
          </div>
          
          <h2 className="page-title">المعاملات</h2>
          <hr />
        </div>

        {/* Content */}
        <div className="transaction-log-content" id="TransactionTableDiv">
          {loading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>جاري تحميل سجل المعاملات...</p>
            </div>
          ) : error ? (
            <div className="error-container">
              <p className="error-message">{error}</p>
              <button onClick={fetchLogs} className="retry-btn">
                إعادة المحاولة
              </button>
            </div>
          ) : logs.length === 0 ? (
            <div className="empty-container">
              <p>لا توجد معاملات لهذه الاستمارة</p>
            </div>
          ) : (
            <div className="table-container">
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>اسم المستخدم</th>
                    <th>تاريخ العملية</th>
                    <th>نوع العملية</th>
                    <th>رقم العينة</th>
                    <th>باركود عينة الHVD</th>
                    <th>الحالة القديمة</th>
                    <th>الحالة الجديدة</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log, index) => (
                    <tr key={log.id || index}>
                      <td>{log.username}</td>
                      <td>{formatDate(log.operationDate)}</td>
                      <td>
                        <span className={`operation-badge ${log.operationTypeEn}`}>
                          {log.operationType}
                        </span>
                      </td>
                      <td>{log.sampleNumber || ''}</td>
                      <td className="barcode">{log.hvdBarcode || ''}</td>
                      <td>
                        {log.oldStatusAr && (
                          <span className={`status-badge ${log.oldStatus}`}>
                            {log.oldStatusAr}
                          </span>
                        )}
                      </td>
                      <td>
                        <span className={`status-badge ${log.newStatus}`}>
                          {log.newStatusAr}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Footer Actions */}
        <div className="transaction-log-actions print-buttons">
          <button onClick={printLogs} className="btn btn-success btn-md">
            
            <>طباعة</>
          </button>
          <button onClick={onClose} className="btn btn-danger btn-md">
            
            <>إغلاق</>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionLog;